module.exports = __webpack_public_path__ + "static/media/icon-firearm.7e91c37d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-firearm.svg
// module id = 991
// module chunks = 0